import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/cn';

export interface BrandProps {
  className?: string;
  logoUrl?: string | null;
}

export function Brand({ className, logoUrl }: BrandProps) {
  if (!logoUrl) return null;

  return (
    <Link
      to="/"
      aria-label="Home"
      className={cn('inline-flex shrink-0 items-center', className)}
    >
      <img src={logoUrl} alt="Brand logo" className="block h-[17px] w-auto max-w-[160px] object-contain" />
    </Link>
  );
}
